<template>
  <div 
    class="messager-container"
  >
    <div class="messager-icon"
        v-on:click="toggleMessager"
    >   
        <a-badge
            :count="5"
        >
            <a-icon
                type="message"
                class="icon"
            >

            </a-icon>
        </a-badge>
        
    </div>
    <div class="messager-ui">
        <MessagerUiComponent />
    </div>
  </div>
</template>

<script>
import MessagerUiComponent from './MessagerUiComponent.vue';

export default {

    components: {
        MessagerUiComponent
    },

    data() {
        return {
            messagerState: 'closed'
        }
    },

    methods: {
        toggleMessager($event) {
            $event.preventDefault();
            if (this.messagerState === 'closed') {
                this.setMessagerState('open');
            } else if (this.messagerState === 'open') {
                this.setMessagerState('closed');
            }
        },

        setMessagerState(state) {
            this.messagerState = state;
        }
    }
}
</script>

<style lang="scss" scoped>
    .messager-container {
        position: relative;


        .messager-icon {
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;

            position: absolute;
            right: -1.8rem;
            bottom: 1.8rem;
            width: 50px;
            height: 50px;
            border-radius: 50%;
            background-color: $primary-blue;

            .icon {
                color: white;
                font-size: 32px;
            }
        }
    }
</style>